module.exports = {
  FEEDBACK: 'feedback',
  NPS: 'nps',
  MOST_LIKED: 'mostliked',
  IMPROVE_REASON: 'toimprove',
  CHANNEL: 'channel'
}
